// extracted by mini-css-extract-plugin
export default {"poweredBy":"PoweredBy_poweredBy__lFgOT"};